import { AppsContainerGroup, HandleOpenModalType } from "types/apps-container";

import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ApplicationGroup from "./applicationgroup";
import GoAiguaButton from "./goaiguabutton";

import { useTranslation } from "utils/hooks/use-translation.hook";
import { useAppsContainerTabContext } from "storage/context/apps-container-tab-context";

type ApplicationsSectionType = {
    title: string;
    sectionData: AppsContainerGroup[];
    isGoAigua: boolean;
    handleOpenModal: HandleOpenModalType;
    openCreateSubGroupModal: (target: string) => void;
};

const ApplicationsSection = ({
    sectionData,
    title,
    isGoAigua,
    handleOpenModal,
    openCreateSubGroupModal,
}: ApplicationsSectionType) => {
    const translate = useTranslation();

    const { isAdminUser, isImplantUser, editActive } =
        useAppsContainerTabContext();

    const sortContainersCallback = (
        prev: AppsContainerGroup,
        current: AppsContainerGroup
    ) => {
        return prev.containerOrder - current.containerOrder;
    };

    const handleEditButtonClick = () => {
        handleOpenModal({
            content: "edit",
            data: sectionData,
            itemToEditName: title,
            editMode: "group",
        });
    };

    const checkUserCanEdit = () => {
        if (!editActive) return false;

        if (isImplantUser) return true;
        if (isAdminUser && !isGoAigua) return true;

        return false;
    };

    const userCanEdit = checkUserCanEdit();

    return (
        <article className="c-applications-section">
            <header className="c-applications-section__title-container">
                <h2 className="c-applications-section__title">{title}</h2>

                <hr className="c-applications-section__line" />

                {userCanEdit && (
                    <button
                        onClick={handleEditButtonClick}
                        className="c-applications-section__edit-button"
                    >
                        <FontAwesomeIcon icon={faEdit} />
                        <span>{translate("app.welcome.page.edit_group")}</span>
                    </button>
                )}
            </header>

            <div className="c-applications-section__groups-container">
                {sectionData.sort(sortContainersCallback).map((group) => {
                    if (!group.visible) return null;

                    return (
                        <ApplicationGroup
                            key={group.id}
                            data={group}
                            canBeEdited={userCanEdit}
                            handleOpenModal={handleOpenModal}
                        />
                    );
                })}

                {userCanEdit && (
                    <section className="c-application-group">
                        <div className="c-application-group__list c-applications-section__add-button-container">
                            <GoAiguaButton
                                text={translate("app.welcome.page.add_subgroup")}
                                className="goaigua-button-outline c-applications-section__add-button"
                                onClick={() => openCreateSubGroupModal(title)}
                            />
                        </div>
                    </section>
                )}
            </div>
        </article>
    );
};

export default ApplicationsSection;
